export const FREE_CLICK_AND_COLLECT_THRESHOLD = 40;

export enum DeliveryMessage {
  FreeStandardDelivery = "Free standard delivery",
  FreeStandardDeliveryOverThreshold = "Free standard delivery over {price}",
  FreeStandardDeliveryOverThresholdNew = "Free standard delivery over {price}, otherwise from £4.50",
  FreeUKMainlandDelivery = "Free UK mainland delivery",
  FreeUKMainlandDeliveryOverThreshold = "Free UK mainland delivery over £70",
  None = "",
}
